import { Route, Routes } from 'react-router-dom';
import { LocalePage } from './pages/LocalePage';
import { LocaleRoute } from './pages/LocaleRoute';

export const App = () => (
  <Routes>
    <Route path="/" element={<LocalePage locale="en" />} />
    <Route path="/:locale" element={<LocaleRoute />} />
  </Routes>
);
